// removed by extract-text-webpack-plugin
module.exports = {"container":"container___2g2bv","content":"content___2BgIR","newModel":"newModel___1zdny","header":"header___2IqIC","saveButton":"saveButton___2nJ_z","errorText":"errorText___1Q1Z9","requestTitle":"requestTitle___2FsE7","inputField":"inputField___1h1iP","multiSelect":"multiSelect___2XwBP","required":"required___2EoIv"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/CreateRequest/CreateRequest.module.css
// module id = 368
// module chunks = 0